var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.715 14.312h-1.25v-.7a.309.309 0 0 0-.618 0v.7h-2.785v-.7a.309.309 0 0 0-.617 0v.7h-2.786v-.7a.309.309 0 0 0-.617 0v.7H7.256v-.7a.309.309 0 0 0-.617 0v.7H3.854v-.7a.309.309 0 0 0-.617 0v.7H.617v-1.996h.66a.309.309 0 0 0 0-.617h-.66V9.82h.66a.309.309 0 0 0 0-.617h-.66V7.325h.66a.309.309 0 0 0 0-.617h-.66v-1.88h.66a.309.309 0 0 0 0-.616h-.66v-1.88h.66a.309.309 0 0 0 0-.616h-.66V.309a.309.309 0 0 0-.617 0V14.62c0 .17.138.308.309.308h18.407a.309.309 0 0 0 0-.617z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.617 9.662c-1.008-.504-1.98-2.118-3.98-2.118a.308.308 0 0 0-.09.013.308.308 0 0 0-.09-.013l-.15.003a6.542 6.542 0 0 1-.142-.622c-.471-2.673-1.213-5.43-3.143-5.598a.309.309 0 0 0-.06 0 .31.31 0 0 0-.059 0c-1.93.169-2.672 2.925-3.143 5.598-.224 1.268-.776 2.348-1.64 3.212-.65.648-1.243.924-1.249.927a.308.308 0 0 0 .256.562c.027-.013.682-.314 1.408-1.032.665-.659 1.524-1.811 1.832-3.562.603-3.416 1.401-4.986 2.59-5.09h.011c1.189.104 1.987 1.674 2.59 5.09.036.207.08.406.132.597-1.506.341-2.345 1.599-3.213 2.033-.995.497-2.269.533-2.282.533a.308.308 0 0 0 .014.617c.058-.001 1.423-.038 2.544-.599.998-.499 1.761-1.716 3.122-1.994a6.451 6.451 0 0 0 1.516 2.375c.725.718 1.38 1.02 1.407 1.032a.309.309 0 0 0 .255-.562c-.02-.01-1.709-.8-2.542-2.908a.31.31 0 0 0 .036-.008.308.308 0 0 0 .09.013c1.748 0 2.568 1.485 3.704 2.052 1.121.561 2.486.598 2.544.599a.309.309 0 0 0 .013-.617c-.012 0-1.282-.034-2.281-.533z",
    fill: "#3CC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartInfo);
export default __webpack_public_path__ + "static/media/chart_info.9522fe25acffed4f0500c07433841e20.svg";
export { ForwardRef as ReactComponent };